import {
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputLeftAddon,
  InputRightAddon,
  SimpleGrid,
} from '@chakra-ui/react'
import VitalStatsInputLabel from '../../../../components/VitalStatsInputLabel'
import { VitalStatsInputProps } from '../utils/types'

export const AdditionalVitalStatsFields = ({
  stats,
  update,
}: VitalStatsInputProps) => {
  return (
    <SimpleGrid columns={[1, 2]} spacing={4}>
      <FormControl>
        <VitalStatsInputLabel
          url={
            'https://www.amazon.com/Med-Lab-Diagnostics-Urinalysis-Alkalinity/dp/B06XG6MYXD?keywords=ph+strips&qid=1675111722&sr=8-9&linkCode=sl1&tag=ouofthbo024-20&linkId=f4bd23a0356912310fd046f79c85ce06&language=en_US&ref_=as_li_ss_tl'
          }
          title='pH Test (Urine - AM Before Eating)'
        />
        <Input
          type='number'
          step='any'
          value={stats.phTestUrine ?? ''}
          onChange={(e) => {
            update({ phTestUrine: parseFloat(e.target.value) })
          }}
        />
      </FormControl>
      <FormControl>
        <VitalStatsInputLabel
          url={
            'https://www.amazon.com/Med-Lab-Diagnostics-Urinalysis-Alkalinity/dp/B06XG6MYXD?keywords=ph+strips&qid=1675111722&sr=8-9&linkCode=sl1&tag=ouofthbo024-20&linkId=f4bd23a0356912310fd046f79c85ce06&language=en_US&ref_=as_li_ss_tl'
          }
          title='pH Test (Saliva - AM Before Eating)'
        />
        <Input
          type='number'
          step='any'
          value={stats.phTestSaliva ?? ''}
          onChange={(e) => {
            update({
              phTestSaliva: parseFloat(e.target.value),
            })
          }}
        />
      </FormControl>
      <FormControl>
        <VitalStatsInputLabel
          title='Basal Body Temperature'
          description='Underarm tempurature in the morning before you get up with a basal thermometer.'
          url={
            'https://www.amazon.com/iProven-Basal-Thermometer-Jumbo-Backlight/dp/B0BNL95N2V/ref=sr_1_4_sspa?crid=VNOB56S8GBTN&keywords=basal+thermometer+for+ovulation&qid=1675113549&sprefix=basal+thermometer%22%2Caps%2C136&sr=8-4-spons&psc=1&spLa=ZW5jcnlwdGVkUXVhbGlmaWVyPUExVFZOQjUxRFRPWU5YJmVuY3J5cHRlZElkPUEwNDc1NTkwMlhQOTk2RkJVRDBYOCZlbmNyeXB0ZWRBZElkPUEwNjgzODI1MTROUkdXVTlRUzdSOCZ3aWRnZXROYW1lPXNwX2F0ZiZhY3Rpb249Y2xpY2tSZWRpcmVjdCZkb05vdExvZ0NsaWNrPXRydWU='
          }
        />
        <Input
          type='number'
          step='any'
          value={stats.basalBodyTemperature ?? ''}
          onChange={(e) => {
            update({
              basalBodyTemperature: parseFloat(e.target.value),
            })
          }}
        />
      </FormControl>
      <FormControl>
        <VitalStatsInputLabel
          title='Leukocytes (Urine)'
          description='May be an indication of infection'
        />
        <Input
          type='number'
          step='any'
          value={stats.leukocytesUrine ?? ''}
          onChange={(e) => {
            update({
              leukocytesUrine: parseFloat(e.target.value),
            })
          }}
        />
      </FormControl>
      <FormControl>
        <VitalStatsInputLabel
          title='Nitrites (Urine)'
          description='May be an indication of infection'
        />
        <Input
          type='number'
          step='any'
          value={stats.nitriesUrine ?? ''}
          onChange={(e) => {
            update({
              nitriesUrine: parseFloat(e.target.value),
            })
          }}
        />
      </FormControl>
      <FormControl>
        <FormLabel>Ketones (Urine)</FormLabel>
        <Input
          type='number'
          step='any'
          value={stats.ketonesUrine ?? ''}
          onChange={(e) => {
            update({
              ketonesUrine: parseFloat(e.target.value),
            })
          }}
        />
      </FormControl>
      <FormControl>
        <VitalStatsInputLabel
          title='Specific Gravity (Urine)'
          description='Indicator of hydration status'
        />
        <Input
          type='number'
          step='any'
          value={stats.specificGravityUrine ?? ''}
          onChange={(e) => {
            update({
              specificGravityUrine: parseFloat(e.target.value),
            })
          }}
        />
      </FormControl>
      <FormControl>
        <FormLabel>Glucose (Urine)</FormLabel>
        <Input
          type='number'
          step='any'
          value={stats.glucoseUrine ?? ''}
          onChange={(e) => {
            update({
              glucoseUrine: parseFloat(e.target.value),
            })
          }}
        />
      </FormControl>
      <FormControl>
        <FormLabel>Glucose (Fasting Blood)</FormLabel>
        <Input
          type='number'
          step='any'
          value={stats.glucoseFasted ?? ''}
          onChange={(e) => {
            update({
              glucoseFasted: parseFloat(e.target.value),
            })
          }}
        />
      </FormControl>
      <FormControl>
        <FormLabel>Glucose Level (30 Min. After Meal Blood)</FormLabel>
        <Input
          type='number'
          step='any'
          value={stats.glucoseAfterMeal ?? ''}
          onChange={(e) => {
            update({
              glucoseAfterMeal: parseFloat(e.target.value),
            })
          }}
        />
      </FormControl>
      <FormControl>
        <VitalStatsInputLabel
          url='https://www.amazon.com/dp/B09C1W1V2F/ref=cm_sw_r_sms_api_i_CD7EWTG0WSYNWVCA44KV'
          title='Grip Strength'
        />
        <SimpleGrid columns={2} spacing={2}>
          <InputGroup>
            <InputLeftAddon>Left</InputLeftAddon>
            <Input
              type='number'
              step='any'
              value={stats.gripLeft ?? ''}
              onChange={(e) => {
                update({
                  gripLeft: parseFloat(e.target.value),
                })
              }}
            />
          </InputGroup>
          <InputGroup>
            <InputLeftAddon>Right</InputLeftAddon>
            <Input
              type='number'
              step='any'
              value={stats.gripRight ?? ''}
              onChange={(e) => {
                update({
                  gripRight: parseFloat(e.target.value),
                })
              }}
            />
          </InputGroup>
        </SimpleGrid>
      </FormControl>

      <FormControl>
        <VitalStatsInputLabel
          url='https://www.amazon.com/8889992-Mouthpiece-Spirometer-Disposable-Diagnostics/dp/B00D7C4O5K/ref=sr_1_11?crid=DQ9E27Y3M3MC&keywords=peak+flow+meter+manual&qid=1652750420&sprefix=peak+flow+meter+%2Caps%2C101&sr=8-11#immersive-view_1652750684411'
          title='Peak Flow Meter Value (0-850)'
        />
        <Input
          type='number'
          step='any'
          min={0}
          max={850}
          value={stats.peakFlow ?? ''}
          onChange={(e) => {
            update({ peakFlow: parseFloat(e.target.value) })
          }}
        />
      </FormControl>
      <FormControl>
        <VitalStatsInputLabel
          title='FVC (Only If Measured by Respiratory Therapist)'
          description='Forced Vital Capacity - Leave blank if you have not seen a respiratory therapist this month.'
        />
        <InputGroup>
          <Input
            type='number'
            step='any'
            value={stats.fvc ?? ''}
            onChange={(e) => {
              update({ fvc: parseFloat(e.target.value) })
            }}
          />
          <InputRightAddon children='%' />
        </InputGroup>
      </FormControl>
      <FormControl>
        <VitalStatsInputLabel
          title='SVC (Only If Measured by Respiratory Therapist)'
          description='Slow Vital Capacity - Leave blank if you have not seen a respiratory therapist this month.'
        />
        <InputGroup>
          <Input
            type='number'
            step='any'
            value={stats.svc ?? ''}
            onChange={(e) => {
              update({ svc: parseFloat(e.target.value) })
            }}
          />
          <InputRightAddon children='%' />
        </InputGroup>
      </FormControl>
    </SimpleGrid>
  )
}
